import React, { useState, useEffect } from "react";

import { MdEditLocationAlt } from "react-icons/md";
import "./Payment.css";
import { AiFillCar } from "react-icons/ai";
import { BsPersonFill } from "react-icons/bs";
import { bookeVehicle } from "../../redux/CustomerReducer";
import { MdPayment } from "react-icons/md";
import { MdOutlineArrowDropDown } from "react-icons/md";
import StripeCheckout from "react-stripe-checkout";
import Swal from "sweetalert2";
import { MdLocationOn } from "react-icons/md";
import Cookies from "universal-cookie";
import { BsCash } from "react-icons/bs";
import { FaRegCreditCard } from "react-icons/fa";
import { BiPound } from "react-icons/bi";
import { MdDateRange } from "react-icons/md";
import { HiOutlineInformationCircle } from "react-icons/hi";

import { SERVERURL } from "../../ServerUrl";
import pic from "./../../assets/images/car.png";
import { useLocation } from "react-router-dom";
import logo from "./../../assets/images/logo.png";
import { IoMdBus } from "react-icons/io";
import { useDispatch } from "react-redux";
import moment from "moment";
import { useSelector } from "react-redux";
import { BiLoaderAlt } from "react-icons/bi";
import BookingAddressDetail from "../BookingAddressDetail/BookingAddressDetail";

const Payment = () => {
  const userPayment = useSelector(
    (state) => state.CustomerReducer?.currentCustomer?.user
  );
  const [noOfPassenger, setNoOfPassenger] = useState(0);
  const [valueSelected, setValueSelected] = useState(0);
  const [valueSelected1, setValueSelected1] = useState(0);
  const [valueSelected2, setValueSelected2] = useState(0);
  const [payMethod, setPayMethod] = useState();
  const[valid1,setValid1]=useState();
  const[valid2,setValid2]=useState();
  const[valid3,setValid3]=useState();
  const[user,setUser]=useState({
    name:userPayment?.name,
    email:userPayment?.email,
    phone:userPayment?.phone
  });
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const bookingDataRed = useSelector(
    (state) => state?.CustomerReducer?.setObjBookingDetData
  );
  const totalAmount = useSelector(
    (state) => state.CustomerReducer?.setTotalValueData
  );
 
  console.log("userPayment", userPayment);
  const location = useLocation();
  const cookies = new Cookies();
  console.log("locationPassenger passenger", location?.state?.passenger);
  console.log(
    "locationPassenger bookingAmount",
    location?.state?.bookingAmount
  );
  console.log(
    "locationPassenger arrivalLocation",
    location?.state?.arrivalLocation
  );
  console.log(
    "locationPassenger pickUpLocation",
    location?.state?.pickUpLocation
  );
  console.log("locationPassenger pickUpDate", location?.state?.pickUpDate);
  console.log("locationPassenger pickUpTime", location?.state?.pickUpTime);
  console.log(
    "locationPassenger returnPickUpTime",
    location?.state?.returnPickUpTime
  );
  console.log(
    "locationPassenger returnPickUpDate",
    location?.state?.returnPickUpDate
  );
  console.log("totalAmount", totalAmount);
  const noOfPassClicked = (index) => {
    setValueSelected(index);
    setNoOfPassenger(4);
  };
  const noOfPassClicked1 = (index) => {
    setValueSelected1(index);
    setNoOfPassenger(4);
  };
  const noOfPassClicked2 = (index) => {
    setValueSelected2(index);
    setNoOfPassenger(4);
  };
  const passengerClicked = () => {
    if (noOfPassenger != 1) {
      setNoOfPassenger(1);
    } else {
      setNoOfPassenger(4);
    }
  };
  const passengerClicked1 = () => {
    if (noOfPassenger != 2) {
      setNoOfPassenger(2);
    } else {
      setNoOfPassenger(4);
    }
  };
  const handLuggageClicked = () => {
    if (noOfPassenger != 3) {
      setNoOfPassenger(3);
    } else {
      setNoOfPassenger(4);
    }
  };
  const luggageClicked = () => {
    if (noOfPassenger != 2) {
      setNoOfPassenger(2);
    } else {
      setNoOfPassenger(4);
    }
  };

  useEffect(() => {
    // simulate an async action
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []); // pass an empty array to only run this effect once

  const [product, setProduct] = useState({
    name: "React from FB",
    price: totalAmount,
    productKey: "facebook",
  });
  const makePayment = (token) => {
    const body = {
      token,
      product,
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return fetch(`${SERVERURL}/payment`, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    })
      .then((response) => {
        console.log(response);
        const { status } = response;
        console.log("STATUS", status);
      })
      .catch((error) => console.log(error));
  };

  console.log("bookingDataRed", bookingDataRed);

  const payInCarClicked = () => {
    setPayMethod(2);
  };
  const payWithCardClicked = () => {
    console.log("payWithCardClicked");
    setPayMethod(1);
  };

  console.log("PPPlocation?.state?", location?.state);
  const userId = cookies.get("_id");

  // console.log("vehiclesData", vehiclesData);

  let idOfUser = "";

  if (userId) {
    idOfUser = userId;
  }

  const bookedClicked = async () => {
   
    let pickupTime;
    if (location?.state.startDateHourly) {
      pickupTime = moment(location?.state.startDateHourly).format("YYYY-MM-DD");
    }
    if (location?.state?.departureTime) {
      pickupTime = location?.state?.departureTime;
    }
    if(user.email&&user.name&&user.phone)
    {
      const data = {
     
        bookingAmount: location?.state?.price,
        pickUpLocation: location?.state?.departureLocation,
        arrivalLocation: location?.state?.arrivalLocation,
        pickUpDate: location?.state?.departureDate,
        pickUpTime: pickupTime,
        returnPickUpTime: location?.state?.arrivalTime,
        returnPickUpDate: location?.state?.departureDate,
        hourlyDuration: location?.state?.hourlyDuration,
        userId: idOfUser,
        email: user.email,
        phone: user.phone,
        name: user.name,
      };
  
      const response = await dispatch(bookeVehicle(data));
      console.log("response", response?.payload?.data?.message);
      Swal.fire(response?.payload?.data?.message, "success");

    }
    else{

        if(!user.email)
        {
setValid1(true)
        }
        if(!user.name)
        {
setValid2(true)
        }
        if(!user.phone)
        {
setValid3(true)
        }
    }

   
  };



  const handleChange=(e)=>{

    const{name,value}=e.target;

    setUser({...user,[name]:value})

    if(user.email)
    {
setValid1(false)
    }
    if(user.name)
    {
setValid2(false)
    }
    if(user.phone)
    {
setValid3(false)
    }
  }

  console.log("location?.state?.catagory",location?.state?.catagory)
  return (
    <>
      <div>
        {isLoading ? (
          <div className="mainContainerLoader">
            <img src={logo} className="logoAlertImg" />

            {/* <div className="alertTxt">Please wait .....</div> */}

            <div className="topLoaderIconsAlert">
              <IoMdBus className="busIcon" />
              <BiLoaderAlt className="loaderIconAlert" />
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="topMainStepperFields">
        <div className="mainStepper">
          <div className="topStepperSingle">
            <div className="topIconDesc">
              <div className="stepperCircle">
                <MdEditLocationAlt className="iconStepper" />
              </div>
              <div className="steppeBtmTxt">Journey</div>
            </div>
            <div className="stepperLine"></div>
          </div>
          <div className="topStepperSingle">
            <div className="topIconDesc">
              <div className="stepperCircle">
                <AiFillCar className="iconStepper" />
              </div>
              <div className="steppeBtmTxt">Vehicle</div>
            </div>
            <div className="stepperLine"></div>
          </div>

          <div className="topStepperSingle">
            <div className="topIconDesc">
              <div className="stepperCircle">
                <MdPayment className="iconStepper" />
              </div>
              <div className="steppeBtmTxt">Payment</div>
            </div>
          </div>
        </div>

        <BookingAddressDetail />

        <div className="mainAirDetailPayment">
          <div className="mainAirDetailPaymentInner">
            <div className="airportTxt">Airport pickup details</div>
            <div className="descPaymentAir">
              Enter just your flight number. Your chauffeur will track the
              location and status and pick you up when your flight arrives, even
              if it’s delayed.
            </div>
            <div className="topFlightVehicle">
            <div className="topInputFlightNo">
              <div className="inputDescTxtPay">Flight number</div>
              <input
                placeholder="e.g. LH 202, U24657, BA2490"
                className="inputPayment"
              />
            </div>
<div className="topVehiCClassPaymen">

  
            <div className="cataTxtPaym"> {location?.state?.catagory}</div>
            <img className="paymentVehiclImg" src={location?.state?.image}/>
</div>
            </div>
            
            <div className="topAddiInfoPay">
              <div className="additionInfTxt">Additional info</div>
              <div className="topAddInputs">
                <div className="topAddInputsInner">
                  <div className="inputDescTxtPay">Pickup sign</div>
                  <input placeholder="John Doe" className="inputPayment" />
                </div>
                <div className="topAddInputsInner">
                  <div className="inputDescTxtPay">Name</div>
                  {!userPayment?.name && (
                    <input className="inputPayment" placeholder="Name"
                    style={{border:valid2?"1px solid red":""}}
                    onChange={handleChange}
                    name="name"
                    value={user.name}
                    />
                  )}
                                {valid2&&    <div style={{color:"red"}}>Required</div>}

                  {userPayment?.name && (
                    <div className="inputPayment1">{userPayment.name}</div>
                  )}
                </div>
                <div className="topAddInputsInner">
                  <div className="inputDescTxtPay">Email</div>
                  {!userPayment?.email && (
                    <input placeholder="Email" className="inputPayment" 
                    onChange={handleChange}
                    name="email"
                    value={user.email}
                    
                    style={{border:valid1?"1px solid red":""}}                    />
                  )}
              {valid1&&    <div style={{color:"red"}}>Required</div>}

                  {userPayment?.email && (
                    <div className="inputPayment1"> {userPayment.email}</div>
                  )}
                </div>
                <div className="topAddInputsInner">
                  <div className="inputDescTxtPay">Contact Number</div>
                  {!userPayment?.phone && (
                    <input
                      placeholder="Contact Number"
                      className="inputPayment"
                      style={{border:valid3?"1px solid red":""}}
                      onChange={handleChange}
                      name="phone"
                      value={user.phone}
                    />
                  )}
                    {valid3&&    <div style={{color:"red"}}>Required</div>}
                  {userPayment?.phone && (
                    <div className="inputPayment1">{userPayment?.phone}</div>
                  )}
                </div>

                <div className="topAddInputsInner">
                  <div className="inputDescTxtPay">Enter discount code</div>
                  <input
                    placeholder="Enter discount code"
                    className="inputPayment"
                  />
                </div>
                <div className="topAddInputsInner topAddInputsInnerBooking">
                  <div className="airportTxt">Payment Info</div>
                  {/* <div className="youPayTxt">You Pay: £ {location?.state?.price}</div> */}
                  <div className="topBookPrice" onClick={bookedClicked}>
                    <div> £ {location?.state?.price}</div>
                    <div>Book Now</div>
                  </div>
               
                </div>
                <div className="topAddInputsInner">
                <div className="inputDescTxtPay">Instructions for driver</div>
                <textarea
                  placeholder="Instructions for driver"
                  className="inputPayment"
                />
                </div>
              </div>
              {/* <div className="topAddInputsInner">
                <div className="inputDescTxtPay">Instructions for driver</div>
                <textarea
                  placeholder="Instructions for driver"
                  className="inputPayment"
                />
              </div> */}
              <div className="cancellationNotic">
                <strong>Note:</strong> Cancellation notice period should be at
                least 24 hours before the booking time. Additional charges may
                be applicable for any changes in route, waiting time, additional
                stops, address changes or vehicle changes. All Airport pickups
                and out of town pickups will need to be paid in full atleast 12
                hours before the travel time otherwise booking will be cancelled
                thank you for understanding
              </div>
            </div>
          </div>

          {/* <div className="rightPaymentPart">
            <div className="airportTxt">Payment Info</div>
            <div className="youPayTxt">You Pay: £ {location?.state?.price}</div>
            <div className="topBookPrice" onClick={bookedClicked}>
              <div> £ {location?.state?.price}</div>
              <div>Book Now</div>
            </div>
          </div> */}
        </div>

        {/* <div className="mainContainerPayment">
          <div className="paymentHeader">
            <HiOutlineInformationCircle />
            <div>Journey Details</div>
          </div>
          <div className="topAftrR1Payment">
            <div className="topMainContainerPaymentInputs">
              <div className="mainContainerPaymentInputs">
                <div className="paymentR1Data">
                  <div className="pickUpTimeDteDetLbl">
                    Pick Up time <br /> & date
                  </div>
                  <div className="topRigghtR1Payment">
                    <div className="topDateDateTimePay">
                      <div className="inputPaymentLbl">Pickup Date:</div>

                      <div className="dateSelectPaymentDteTime">
                        {moment(bookingDataRed?.pickUpDate).format(
                          "YYYY-MM-DD"
                        )}
                      </div>
                    </div>

                    <div className="topDateDateTimePay">
                      <div className="inputPaymentLbl">Pickup Time:</div>

                      <div className="dateSelectPaymentDteTime">
                        {bookingDataRed?.pickUpTime}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="paymentR2Data">
                  <div className="inputPaymentLbl inputPaymentLbl1">
                    Pick Up
                  </div>
                  <div className="addressPaymentDet">
                    {bookingDataRed?.pickUpLocation}
                  </div>
                </div>
                <div className="paymentR2Data">
                  <div className="inputPaymentLbl inputPaymentLbl1">
                    Drop Off
                  </div>
                  <div className="addressPaymentDet">
                    {bookingDataRed?.arrivalLocation}
                  </div>
                </div>

                <div className="mainPassengerInfoPart">
                  <div className="inputPaymentLbl inputPaymentLbl1">
                    Flight <br />
                    Information
                  </div>

                  <div className="mainInputFieldsPayment">
                    <div className="topLuggageFields">
                      <input
                        className="inputFieldPassenger"
                        placeholder="Flight Number"
                      />
                      <input
                        className="inputFieldPassenger"
                        placeholder="Arriving From"
                      />
                    </div>
                  </div>
                </div>
                {!userPayment?._id && (
                  <div className="mainPassengerInfoPart">
                    <div className="inputPaymentLbl inputPaymentLbl1">
                      Passenger <br />
                      Information
                    </div>

                    <div className="mainInputFieldsPayment">
                      <div className="topLuggageFields">
                        <input
                          className="inputFieldPassenger"
                          placeholder="Name *"
                        />
                        <input
                          className="inputFieldPassenger"
                          placeholder="Email *"
                        />
                        <input
                          className="inputFieldPassenger"
                          placeholder="Contact number *"
                        />
                      </div>
                    </div>
                  </div>
                )}

                {userPayment?.name && (
                  <div className="mainPassengerInfoPart">
                    <div className="inputPaymentLbl inputPaymentLbl1 perInfoPay">
                      Name
                    </div>

                    <div className="mainInputFieldsPayment">
                      <div className="topLuggageFields">
                        <div className="inputFieldPassenger">
                          {userPayment?.name}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {userPayment?.email && (
                  <div className="mainPassengerInfoPart">
                    <div className="inputPaymentLbl inputPaymentLbl1 perInfoPay">
                      Email
                    </div>

                    <div className="mainInputFieldsPayment">
                      <div className="topLuggageFields">
                        <div className="inputFieldPassenger">
                          {userPayment?.email}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {userPayment?.phone && (
                  <div className="mainPassengerInfoPart">
                    <div className="inputPaymentLbl inputPaymentLbl1 perInfoPay">
                      Phone Number
                    </div>

                    <div className="mainInputFieldsPayment">
                      <div className="topLuggageFields">
                        <div className="inputFieldPassenger">
                          {userPayment?.phone}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="mainPassengerInfoPart">
                  <div className="inputPaymentLbl inputPaymentLbl1">
                    Luggage
                    <br />
                    Information
                  </div>

                  <div className="mainInputFieldsPayment">
                  <div className="topLuggageFields">
                        <div className="topEachLuggageArrowPay">
                          <div
                            className="luggagePayment"
                            onClick={passengerClicked}
                          >
                            {valueSelected ? valueSelected : "List of Luggage"}{" "}
                          </div>{" "}
                          <MdOutlineArrowDropDown className="dropArrowLuggPay" />
                          {noOfPassenger == 1 && (
                            <div className="noOfLuggagePayCard">
                              <div className="noOfPassTopPayTxt">
                              Your Luggage List
                              </div>
                              {bookingDataRed?.finalLugagge?.map((item, index) => {
                                return (
                                  <div
                                    className="luggageFirstRow luggageFirstRowPay"
                                  >
                                    {item?.quantity}: {item?.nameLuggae}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                  
                      </div>
                  </div>
                </div>

                <div className="paymentR2Data">
                  <div className="inputPaymentLbl inputPaymentLbl1">
                    Instruction for <br /> driver
                  </div>
                  <textarea className="textAreaPay" />
                </div>
              </div>
              {!bookingDataRed?.makeDisable && (
                <div className="mainContainerPaymentInputs">
                  <div className="paymentR1Data">
                    <div className="pickUpTimeDteDetLbl">
                    Return  time <br /> & date
                    </div>
                    <div className="topRigghtR1Payment">
                      <div className="topDateDateTimePay">
                        <div className="inputPaymentLbl">Return Date:</div>

                        <div className="dateSelectPaymentDteTime">
                          {moment(bookingDataRed?.returnPickUpDate).format(
                            "YYYY-MM-DD"
                          )}
                        </div>
                      </div>

                      <div className="topDateDateTimePay">
                        <div className="inputPaymentLbl">Return Time:</div>

                        <div className="dateSelectPaymentDteTime">
                          {bookingDataRed?.returnPickUpTime}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="paymentR2Data">
                    <div className="inputPaymentLbl inputPaymentLbl1">
                    Return Pick Up
                    </div>
                    <div className="addressPaymentDet">
                    {bookingDataRed?.arrivalLocation}
                    </div>
                  </div>
                  <div className="paymentR2Data">
                    <div className="inputPaymentLbl inputPaymentLbl1">
                    Return Drop Off
                    </div>
                    <div className="addressPaymentDet">
                   
                      {bookingDataRed?.pickUpLocation}
                    </div>
                  </div>

                  <div className="mainPassengerInfoPart">
                    <div className="inputPaymentLbl inputPaymentLbl1">
                      Flight <br />
                      Information
                    </div>

                    <div className="mainInputFieldsPayment">
                      <div className="topLuggageFields">
                        <input
                          className="inputFieldPassenger"
                          placeholder="Flight Number"
                        />
                        <input
                          className="inputFieldPassenger"
                          placeholder="Arriving From"
                        />
                      </div>
                    </div>
                  </div>
                  {!userPayment?._id && (
                    <div className="mainPassengerInfoPart">
                      <div className="inputPaymentLbl inputPaymentLbl1">
                        Passenger <br />
                        Information
                      </div>

                      <div className="mainInputFieldsPayment">
                        <div className="topLuggageFields">
                          <input
                            className="inputFieldPassenger"
                            placeholder="Name *"
                          />
                          <input
                            className="inputFieldPassenger"
                            placeholder="Email *"
                          />
                          <input
                            className="inputFieldPassenger"
                            placeholder="Contact number *"
                          />
                        </div>
                      </div>
                    </div>
                  )}

          
                
                  <div className="mainPassengerInfoPart">
                    <div className="inputPaymentLbl inputPaymentLbl1">
                      Luggage
                      <br />
                      Information
                    </div>

                    <div className="mainInputFieldsPayment">
                      <div className="topLuggageFields">
                        <div className="topEachLuggageArrowPay">
                          <div
                            className="luggagePayment"
                            onClick={passengerClicked1}
                          >
                            {valueSelected ? valueSelected : "List of Luggage"}{" "}
                          </div>{" "}
                          <MdOutlineArrowDropDown className="dropArrowLuggPay" />
                          {noOfPassenger == 2 && (
                            <div className="noOfLuggagePayCard">
                              <div className="noOfPassTopPayTxt">
                              Your Luggage List
                              </div>
                              {bookingDataRed?.finalLugagge?.map((item, index) => {
                                return (
                                  <div
                                    className="luggageFirstRow luggageFirstRowPay"
                                  >
                                    {item?.quantity}: {item?.nameLuggae}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                  
                      </div>
                    </div>
                  </div>

                  <div className="paymentR2Data">
                    <div className="inputPaymentLbl inputPaymentLbl1">
                      Instruction for <br /> driver
                    </div>
                    <textarea className="textAreaPay" />
                  </div>
                </div>
              )}
            </div>
            <div className="secondHalfPayment">
              <div className="topPartContentRightPl">
                <div className="topHeaderTxtPayment">
                  <div className="topHeaderTxtSecHPay">Image</div>
                  <div className="topHeaderTxtSecHPay">Type</div>
                  <div className="topHeaderTxtSecHPay">Description</div>
                </div>
                <div className="topHeaderTxtPayment">
                  <img src={bookingDataRed?.img} className="imgPayment" />
                  <div className="topDescPay">
                    <div className="descSecHalfPay descSecHalfPayMed">
                      {bookingDataRed?.catagory}
                    </div>
                  </div>
                  <div className="topDescPay">
                    <div className="descSecHalfPay">
                      {bookingDataRed?.company}
                    </div>
                  </div>
                </div>
                <div className="topCheckTxtPay">
                  <input type="checkbox" />
                  <div>Meet and Greet</div>
                </div>
              </div>

              <div className="topBtnPayment">
               
                  <div 
                    onClick={payWithCardClicked}
                    className={payMethod==1?"":"topStripeCheckout"}
                  >
                  <StripeCheckout
                
                    stripeKey="pk_test_51LNEcMGMEfjxrtQoskkoXroeTo8ltPAuNltZHrS6wFJogvDxMBODPqAmodv6Fw8xDwfJ19JcXLiMRewgLsiCp1uj00vNdYs2oc"
                    token={makePayment}
                    name="Buy React" 
                    amount={product.price * 100}
                  >
                  </StripeCheckout>
                  </div>

                <button className={payMethod==2 ? "payCardBtn1Clicked":"payCardBtn1"}
                onClick={payInCarClicked}
                >
       
                  Pay In Car
                </button>
              </div>

              <div className="topBtnPayment">
                <button className="btnFarePay">
                  Fare:
                  <BiPound />
                  50:00
                  <div className="crossLineFare"></div>
                </button>
                <button className="btnYouPay">
                  You Pay:
                  <BiPound />
                 {parseInt(bookingDataRed?.bookingAmount)}
                </button>
              </div>

              <div className="finalPriceBtn">
                <span>
                  <BiPound />
                  {parseInt(bookingDataRed?.bookingAmount)}

                </span>
                <span>Book Now</span>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default Payment;
